export const API_SCOPES = [
  'links:read',
  'links:write',
  'analytics:read',
  'analytics:export',
  'keys:read',
  'keys:write',
] as const;

export type ApiScope = (typeof API_SCOPES)[number];

export const DEFAULT_API_SCOPES: ApiScope[] = ['links:read', 'links:write', 'analytics:read'];

export function isApiScope(value: unknown): value is ApiScope {
  return typeof value === 'string' && (API_SCOPES as readonly string[]).includes(value);
}
